export default __webpack_public_path__ + "static/media/hero-metodiInsiemeImageMedium.d787ed51.jpg";